import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-cart-action',
  templateUrl: './cart-action.component.html',
  styleUrls: ['./cart-action.component.css']
})
export class CartActionComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<CartActionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  close(val) {
    this.dialogRef.close(val);
  }

  deleteItem(val) {
    this.dialogRef.close(val);
  }
}
